import { useTranslation } from "react-i18next";

export const UserDisplay = ({ lastName, firstName, email }: { lastName: string; firstName: string; email: string }) => {
	const { t } = useTranslation();

	return (
		<div className="row">
			<div className="col-md-12">
				<div className="row">
					<div className="col-md-3 col-sm-12 col-xs-12">
						<p className="summary-label">{t("lastName")}</p>
						<p className="summary-value">{lastName}</p>
					</div>
					<div className="col-md-3 col-sm-12 col-xs-12">
						<p className="summary-label">{t("firstName")}</p>
						<p className="summary-value">{firstName}</p>
					</div>
					<div className="col-md-3 col-sm-12 col-xs-12">
						<p className="summary-label">{t("email")}</p>
						<p className="summary-value">{email}</p>
					</div>
				</div>
			</div>
		</div>
	);
};
